import type { FC, ReactElement } from "react"

import { OwlHappyImage } from "@/3514/assets"

import { CoachingChatOwlLogoImage as DefaultLogoImage } from "../assets"
import { coachingChatStyles as chatStyles } from "../styles"

const {
    conversation: { owls: classes }
} = chatStyles

type _TDefaultLogoProps = { fill: "blue-500" | "blue-600" }

const DefaultLogo: FC<_TDefaultLogoProps> = ({ fill }: _TDefaultLogoProps): ReactElement => (
    <div className={classes.default.wrapper({ fill })} title="Ollie">
        <DefaultLogoImage className={classes.default.img()} />
    </div>
)

const GuideImage: FC = (): ReactElement => <OwlHappyImage className={classes.guide} />

const logos = { DefaultLogo, GuideImage }

export { logos as coachingChatOwlComponents }
